import type { TFunction } from 'i18next';
import type { FocusGroupTableData } from '../types';

type StatusConfig = Record<
  FocusGroupTableData['status'],
  { label: string; variant: 'positive' | 'warning' | 'secondary' | 'destructive' | 'ghost' }
>;

// A factory, not property getters: `FocusGroupsContent` derives its status filter options
// with `Object.entries`, which would read a getter once and freeze that language in.
export const buildStatusConfig = (t: TFunction<'audiences'>): StatusConfig => ({
  completed: { label: t('audiences.audienceStatusChip.ready'), variant: 'positive' },
  running: { label: t('audiences.audienceStatusChip.inProgress'), variant: 'warning' },
  pending: { label: t('focusGroups.status.pending'), variant: 'secondary' },
  failed: { label: t('audiences.audienceStatusChip.failed'), variant: 'destructive' },
  cancelled: { label: t('focusGroups.status.cancelled'), variant: 'ghost' },
});
